(function () {
  if (window.__nestCartSavingsZeroClear20260703) return;
  window.__nestCartSavingsZeroClear20260703 = true;

  var scheduled = false;
  var running = false;
  var rerunRequested = false;
  var rootSelector = '.cart-modal, #CartDrawer, .cart-drawer, .drawer--cart, .ajax-cart, [data-cart-drawer], [data-cart-container]';
  var compareSelector = 's, strike, del, [class*="compare" i], [class*="original" i], [class*="regular" i], [class*="was" i]';

  function mark(name, detail) {
    if (window.NestLreCartTiming && typeof window.NestLreCartTiming.mark === 'function') {
      window.NestLreCartTiming.mark(name, detail);
    }
  }

  function isVisible(element) {
    if (!element || !document.documentElement.contains(element)) return false;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function moneyToCents(value) {
    var match = String(value || '').replace(/,/g, '').match(/\$+\s*([0-9]+(?:\.[0-9]{1,2})?)/);
    if (!match) return null;
    return Math.round(parseFloat(match[1]) * 100);
  }

  function moneyValues(text) {
    var matches = String(text || '').replace(/,/g, '').match(/\$+\s*[0-9]+(?:\.[0-9]{1,2})?/g) || [];
    return matches.map(moneyToCents).filter(function (value) {
      return typeof value === 'number' && !isNaN(value);
    });
  }

  function formatMoney(cents) {
    return '$' + (Math.max(0, cents) / 100).toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function cartApiSavings(cart) {
    return (cart && cart.items || []).reduce(function (total, item) {
      return total + Math.max((item.original_line_price || 0) - (item.final_line_price || 0), 0);
    }, 0);
  }

  function visibleCartRoot() {
    var preferred = ['.cart-modal', '#CartDrawer', '.cart-drawer', '.drawer--cart', '.ajax-cart'];
    for (var i = 0; i < preferred.length; i += 1) {
      var root = document.querySelector(preferred[i]);
      if (isVisible(root)) return root;
    }
    return Array.prototype.slice.call(document.querySelectorAll(rootSelector)).find(isVisible) || null;
  }

  function nearestPriceScope(compareNode, root) {
    var node = compareNode.parentElement;
    for (var depth = 0; node && node !== root && depth < 8; depth += 1, node = node.parentElement) {
      var text = node.innerText || node.textContent || '';
      var values = moneyValues(text);
      if (values.length >= 2 && text.length < 260) return node;
    }
    return compareNode.parentElement || compareNode;
  }

  function compareNodes(root) {
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll(compareSelector)).filter(function (node) {
      if (!isVisible(node)) return false;
      var value = moneyToCents(node.innerText || node.textContent || '');
      if (!value || value <= 0) return false;
      return !/total savings|subtotal|taxes|checkout/i.test(node.closest('.cart__footer, .cart-footer, footer')?.textContent || '');
    });
  }

  function pairSavings(root) {
    var usedScopes = [];
    return compareNodes(root).reduce(function (total, compareNode) {
      var original = moneyToCents(compareNode.innerText || compareNode.textContent || '');
      if (!original || original <= 0) return total;

      var scope = nearestPriceScope(compareNode, root);
      if (usedScopes.indexOf(scope) > -1) return total;
      usedScopes.push(scope);

      var values = moneyValues(scope.innerText || scope.textContent || '').filter(function (value) {
        return value < original;
      });

      if (!values.length) return total;
      var current = Math.min.apply(Math, values);
      return total + Math.max(0, original - current);
    }, 0);
  }

  function savingsRows(root) {
    if (!root) return [];
    var rows = Array.prototype.slice.call(root.querySelectorAll('.order-discount-card-wrapper')).filter(function (row) {
      return /total savings/i.test(row.textContent || '') || row.getAttribute('data-nest-savings-zero-hidden') === 'true';
    });

    if (rows.length) return rows;

    return Array.prototype.slice.call(root.querySelectorAll('*')).filter(function (node) {
      if (!/total savings/i.test(node.textContent || '')) return false;
      if (!/\$\s*[0-9]/.test(node.textContent || '')) return false;
      return !Array.prototype.slice.call(node.children || []).some(function (child) {
        return /total savings/i.test(child.textContent || '') && /\$\s*[0-9]/.test(child.textContent || '');
      });
    });
  }

  function setRowHidden(row, hidden) {
    if (!row) return;
    if (!row.hasAttribute('data-nest-savings-original-display')) {
      row.setAttribute('data-nest-savings-original-display', row.style.display || '');
    }

    if (hidden) {
      row.style.display = 'none';
      row.setAttribute('hidden', 'hidden');
      row.setAttribute('aria-hidden', 'true');
      row.setAttribute('data-nest-savings-zero-hidden', 'true');
      return;
    }

    row.style.display = row.getAttribute('data-nest-savings-original-display') || '';
    row.removeAttribute('hidden');
    row.removeAttribute('aria-hidden');
    row.removeAttribute('data-nest-savings-zero-hidden');
  }

  function amountLeaf(row) {
    var leaves = Array.prototype.slice.call(row.querySelectorAll('*')).filter(function (node) {
      return node.children.length === 0 && /\$\s*[0-9]/.test(node.textContent || '');
    });
    return leaves[leaves.length - 1] || null;
  }

  function applySavings(apiSavings) {
    var root = visibleCartRoot();
    var fallbackSavings = pairSavings(root);
    var rowSavings = fallbackSavings > 0 ? fallbackSavings : apiSavings;
    var rows = savingsRows(root);
    if (!rows.length) return;

    rows.forEach(function (row) {
      if (rowSavings <= 0) {
        mark('cart savings zero row hidden', (row.textContent || '').replace(/\s+/g, ' ').trim());
        setRowHidden(row, true);
        return;
      }

      setRowHidden(row, false);
      var amount = amountLeaf(row);
      if (amount) amount.textContent = formatMoney(rowSavings);
      mark('cart savings row set', {
        apiSavings: formatMoney(apiSavings || 0),
        pairSavings: formatMoney(fallbackSavings || 0),
        displayed: formatMoney(rowSavings)
      });
    });
  }

  function run() {
    scheduled = false;
    if (running) {
      rerunRequested = true;
      return;
    }
    if (!window.fetch) return;

    running = true;
    window.fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) { applySavings(cartApiSavings(cart)); })
      .catch(function (error) {
        mark('cart savings zero clear error', error && error.message ? error.message : String(error));
      })
      .then(function () {
        running = false;
        if (rerunRequested) {
          rerunRequested = false;
          schedule();
        }
      });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(run, 120);
  }

  document.addEventListener('click', schedule, true);
  document.addEventListener('change', schedule, true);
  document.addEventListener('keyup', schedule, true);

  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  window.setInterval(schedule, 1000);
  schedule();
})();